import MonthView from '../MonthView';

const Header = ({ account, month, handleNewDate, setAnimation }) =>{
  return (
    <div className="bg-app text-white py-2 d-flex">
      <div className="col-7 col-md-7 d-flex align-items-center ps-2" align="left">
        {account?.get("photo") ? (
        <img 
          src={account.get("photo")}
          className="profile-img my-2"
          onError={(e) => {
            e.target.src = "https://placehold.co/100x100"; // Set the fallback image URL on error
          }} />
        ) : (
          <i className="bi bi-person-circle"
            style={{ fontSize: "25px" }} />
        )}

        <span className='fs-5 ps-2'>{account ? account.get("name").substring(0, 30) : ""}</span>
      </div>
      <div className="col-5 col-md-5 cursor pe-3" align="right">
        <MonthView
          selectedDate={month}
          handleNewDate={handleNewDate}
          setAnimation={setAnimation} 
        />
      </div>
    </div>
  )
} 

export default Header;